import React from 'react'
import { withIcon } from '../../withIcon'

function CaretRightIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.34775 18.5793L9.34775 5.42024C9.34775 5.25505 9.43564 5.10438 9.57148 5.03629C9.70632 4.96933 9.86512 4.99611 9.97599 5.10772L16.533 11.6872C16.6918 11.8457 16.6918 12.1538 16.533 12.3134L9.97599 18.8918C9.86512 19.0034 9.70631 19.0313 9.57148 18.9632C9.43564 18.8962 9.34775 18.7456 9.34775 18.5793Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CaretRightIcon)
